import { useFavoriteBuses } from "contexts/FavoriteBusesContext/FavoriteBusesContext";
import React, { useEffect, useState } from "react";
import FilterWrapper from "./filters/FilterWrapper";
import "./Sidebar.scss";
import VoltageSelectWrapper from "./VoltageSelectWrapper";

import { useMapViewRoutingMetadata } from "contexts/RoutingMetadataContext";
import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { hasMultipleScopesForRegionAndGeneratorType } from "types/scope";
import FavoritesPanel from "./FavoritesPanel";
import AllFiltersDialog from "./filters/AllFiltersDialog";
import FavoritesFilter from "./filters/FavoritesFilter";
import OwnersFilter from "./filters/OwnersFilter";
import ScopeSelectFilter from "./filters/ScopeSelectFilter";
import ScopeAssumptionsSection from "./ScopeAssumptionsSection";
import SidebarResultsWrapper from "./SidebarResultsWrapper";

const Sidebar: React.FC = () => {
    const { region, generator, componentConfig } = useMapViewRoutingMetadata();
    const { scopes } = useUserDataContext();
    const {
        favorites,
        favoritesFilterOn,
        favoritesPanelOpen,
        setFavoritesFilterOn,
        setFavoritesPanelOpen
    } = useFavoriteBuses();

    const [allFiltersDialogOpen, setAllFiltersDialogOpen] = useState(false);

    // Switching region closes the panel and clears the filter
    useEffect(() => {
        setFavoritesFilterOn(false);
        setFavoritesPanelOpen(false);
    }, [region, setFavoritesFilterOn, setFavoritesPanelOpen]);

    // Unstarring your last favorite while "Favorites" is on would leave an
    // empty map behind a filter you can no longer see the point of, so drop back
    // to All buses. The button is disabled at zero, so this is the only way in.
    useEffect(() => {
        if (favoritesFilterOn && favorites.length === 0) {
            setFavoritesFilterOn(false);
        }
    }, [favoritesFilterOn, favorites.length, setFavoritesFilterOn]);

    const showOwnersFilter = componentConfig.showOwnersFilter;

    return (
        <div className="Sidebar-wrapper">
            {favoritesPanelOpen ? (
                <FavoritesPanel />
            ) : (
                <>
                    <div className="Sidebar-filter-wrapper">
                        <div className="Sidebar-filter-wrapper-header">
                            <h6 className="bp5-heading">Filters</h6>
                            <div
                                className="Sidebar-show-all-filters bp5-text-small"
                                onClick={() => setAllFiltersDialogOpen(true)}
                            >
                                Show all filters
                            </div>
                        </div>
                        {hasMultipleScopesForRegionAndGeneratorType(
                            scopes,
                            region,
                            generator
                        ) && <ScopeSelectFilter inSidebar={true} />}
                        <FilterWrapper
                            label="Voltage"
                            limitLabelMaxWidth={true}
                        >
                            <VoltageSelectWrapper />
                        </FilterWrapper>
                        {showOwnersFilter && (
                            <FilterWrapper
                                label="Owner"
                                limitLabelMaxWidth={true}
                                helperText="Some owner info comes from third-party data sources and may not match model owner information."
                            >
                                <OwnersFilter />
                            </FilterWrapper>
                        )}
                        <FavoritesFilter inSidebar={true} />
                    </div>
                    <ScopeAssumptionsSection />
                    <SidebarResultsWrapper />
                </>
            )}
            <AllFiltersDialog
                isOpen={allFiltersDialogOpen}
                closeDialog={() => setAllFiltersDialogOpen(false)}
            />
        </div>
    );
};

export default Sidebar;
